<template>
  <div>
    <template cols="12" v-if="allData.componentType === 'title'">
      <!-- 標題 -->
      <v-col
        cols="12"
        class="d-flex mt-2 mb-1 mt-md-2 mb-md-0 px-0 text-justify"
        :class="` ${getTextAlignment()}`"
      >
        <h3
          v-if="
            getTitleStyle().includes('h3') && !getTitleStyle().includes('h4')
          "
          :class="`${getTitleStyle()} ${getTextAlignment()}`"
          class="py-1 font-B"
          v-html="getInfinity(t(allData.data))"
        ></h3>

        <h4
          v-else-if="
            getTitleStyle().includes('h3') && getTitleStyle().includes('h4')
          "
          :class="`${getTitleStyle()} ${getTextAlignment()}`"
          class="py-1 font-B"
          v-html="getInfinity(t(allData.data))"
        ></h4>

        <h2
          v-else-if="
            getTitleStyle().includes('h2') &&
            !getTitleStyle().includes('h3') &&
            !getTitleStyle().includes('h4')
          "
          :class="`${getTitleStyle()} ${getTextAlignment()}`"
          class="py-1"
          v-html="getInfinity(t(allData.data))"
        ></h2>

        <div
          v-else
          :class="`${getTitleStyle()} ${getTextAlignment()}`"
          class="py-1 font-B"
          v-html="getInfinity(t(allData.data))"
        ></div>
      </v-col>
    </template>

    <template cols="12" v-if="allData.componentType === 'min-title'">
      <!-- 標題 -->
      <v-col cols="12" class="pt-0 px-0">
        <div
          class="w-100"
          :class="`${getSubheadStyle()} ${getTextAlignment()}`"
          v-html="getInfinity(t(allData.data))"
        ></div>
      </v-col>
    </template>

    <template cols="12" v-else-if="allData.componentType === 'text'">
      <!-- 內文 + a連結 -->

      <div v-for="(it, textNum) in allData.data" :key="textNum">
        <div v-if="!it.link">
          <p
            class="te-p text-justify"
            v-html="getInfinity(`${t(it.text)}`)"
          ></p>
        </div>
        <div v-else>
          <p class="te-p text-justify" v-html="getlink(it)"></p>
        </div>
      </div>
    </template>

    <template cols="12" v-else-if="allData.componentType === 'list'">
      <!-- list清單 -->
      <!-- <div class="c-list"> -->
      <!-- ul -->
      <ul
        v-if="allData.data.type == 'ul'"
        :style="allData.data.style"
        class="te-p color-te-B"
      >
        <!-- li -->
        <li
          v-for="(allData, i1) in allData.data.data"
          :key="i1"
          :class="i1 != 0 ? 'mt-4' : ''"
        >
          <!-- 第一層內容 有連結 -->
          <p
            v-if="allData.link"
            class="text-justify"
            v-html="getlink(allData)"
          ></p>

          <!-- 第一層內容 無連結-->
          <div v-else>
            <p class="text-justify" v-html="getInfinity(t(allData.text))"></p>
          </div>

          <!-- 第二層ul -->
          <ul
            v-if="allData.data && allData.data.type == 'ul'"
            :style="allData.data.style"
          >
            <!-- 第二層li -->
            <li
              v-for="(allData3, i) in allData.data.data"
              :key="i"
              class="mt-2"
            >
              <!-- 有連結 -->
              <p
                v-if="allData3.link"
                class="mtext-justify"
                v-html="getlink(allData3)"
              ></p>

              <!-- 無連結-->
              <div v-else>
                <p
                  class="text-justify"
                  v-html="getInfinity(t(allData3.text))"
                ></p>
              </div>

              <!-- 第三層ul -->
              <ul
                v-if="allData3.data && allData3.data.type == 'ul'"
                :style="allData3.data.style"
              >
                <!-- 第三層li -->
                <li
                  v-for="(allData4, i) in allData3.data.data"
                  :key="i"
                  class="mt-1"
                >
                  <!-- 有連結 -->
                  <p
                    v-if="allData4.link"
                    class="text-justify"
                    v-html="getlink(allData4)"
                  ></p>

                  <!-- 無連結-->
                  <div v-else>
                    <p
                      class="text-justify"
                      v-html="getInfinity(t(allData4.text))"
                    ></p>
                  </div>
                </li>
              </ul>

              <!-- 第三層ol -->
              <ol
                v-if="allData3.data && allData3.data.type == 'ol'"
                :style="allData3.data.style"
              >
                <!-- 第三層li -->
                <li
                  v-for="(allData4, i) in allData3.data.data"
                  :key="i"
                  class="mt-1"
                >
                  <!-- 有連結 -->
                  <p
                    v-if="allData4.link"
                    class="text-justify"
                    v-html="getlink(allData4)"
                  ></p>

                  <!-- 無連結-->
                  <div v-else>
                    <p
                      class="text-justify"
                      v-html="getInfinity(t(allData4.text))"
                    ></p>
                  </div>
                </li>
              </ol>
            </li>
          </ul>

          <!-- 第二層ol -->
          <ol
            v-if="allData.data && allData.data.type == 'ol'"
            :style="allData.data.style"
          >
            <!-- 第二層li -->
            <li
              v-for="(allData3, i) in allData.data.data"
              :key="i"
              class="mt-2"
            >
              <!-- 有連結 -->
              <p
                v-if="allData3.link"
                class="text-justify"
                v-html="getlink(allData3)"
              ></p>

              <!-- 無連結-->
              <div v-else>
                <p
                  class="text-justify"
                  v-html="getInfinity(t(allData3.text))"
                ></p>
              </div>

              <!-- 第三層ul -->
              <ul
                v-if="allData3.data && allData3.data.type == 'ul'"
                :style="allData3.data.style"
              >
                <!-- 第三層li -->
                <li
                  v-for="(allData4, i) in allData3.data.data"
                  :key="i"
                  class="mt-1"
                >
                  <!-- 有連結 -->
                  <p
                    v-if="allData4.link"
                    class="text-justify"
                    v-html="getlink(allData4)"
                  ></p>

                  <!-- 無連結-->
                  <div v-else>
                    <p
                      class="text-justify"
                      v-html="getInfinity(t(allData4.text))"
                    ></p>
                  </div>
                </li>
              </ul>

              <!-- 第三層ol -->
              <ol
                v-if="allData3.data && allData3.data.type == 'ol'"
                :style="allData3.data.style"
              >
                <!-- 第三層li -->
                <li
                  v-for="(allData4, i) in allData3.data.data"
                  :key="i"
                  class="mt-1"
                >
                  <!-- 有連結 -->
                  <p
                    v-if="allData4.link"
                    class="text-justify"
                    v-html="getlink(allData4)"
                  ></p>

                  <!-- 無連結-->
                  <div v-else>
                    <p
                      class="text-justify"
                      v-html="getInfinity(t(allData4.text))"
                    ></p>
                  </div>
                </li>
              </ol>
            </li>
          </ol>
        </li>
      </ul>

      <!-- ol -->
      <ol
        v-if="allData.data.type == 'ol'"
        :style="allData.data.style"
        class="te-p color-te-B"
      >
        <!-- li -->
        <li
          v-for="(allData, i1) in allData.data.data"
          :key="i1"
          :class="i1 != 0 ? 'mt-4' : ''"
        >
          <!-- 第一層內容 有連結 -->
          <p
            v-if="allData.link"
            class="text-justify"
            v-html="getlink(allData)"
          ></p>

          <!-- 第一層內容 無連結-->
          <div v-else>
            <p class="text-justify" v-html="getInfinity(t(allData.text))"></p>
          </div>

          <!-- 第二層ul -->
          <ul
            v-if="allData.data && allData.data.type == 'ul'"
            :style="allData.data.style"
          >
            <!-- 第二層li -->
            <li
              v-for="(allData3, i2) in allData.data.data"
              :key="i2"
              class="mt-2"
            >
              <!-- 有連結 -->
              <p
                v-if="allData3.link"
                class="text-justify"
                v-html="getlink(allData3)"
              ></p>

              <!-- 無連結-->
              <div v-else>
                <p
                  class="text-justify"
                  v-html="getInfinity(t(allData3.text))"
                ></p>
              </div>

              <!-- 第三層ul -->
              <ul
                v-if="allData3.data && allData3.data.type == 'ul'"
                :style="allData3.data.style"
              >
                <!-- 第三層li -->
                <li
                  v-for="(allData4, i) in allData3.data.data"
                  :key="i"
                  class="mt-1"
                >
                  <!-- 有連結 -->
                  <p
                    v-if="allData4.link"
                    class="text-justify"
                    v-html="getlink(allData4)"
                  ></p>

                  <!-- 無連結-->
                  <div v-else>
                    <p
                      class="text-justify"
                      v-html="getInfinity(t(allData4.text))"
                    ></p>
                  </div>
                </li>
              </ul>

              <!-- 第三層ol -->
              <ol
                v-if="allData3.data && allData3.data.type == 'ol'"
                :style="allData3.data.style"
              >
                <!-- 第三層li -->
                <li
                  v-for="(allData4, i) in allData3.data.data"
                  :key="i"
                  class="mt-1"
                >
                  <!-- 有連結 -->
                  <p
                    v-if="allData4.link"
                    class="text-justify"
                    v-html="getlink(allData4)"
                  ></p>

                  <!-- 無連結-->
                  <div v-else>
                    <p
                      class="text-justify"
                      v-html="getInfinity(t(allData4.text))"
                    ></p>
                  </div>
                </li>
              </ol>
            </li>
          </ul>

          <!-- 第二層ol -->
          <ol
            v-if="allData.data && allData.data.type == 'ol'"
            :style="allData.data.style"
          >
            <!-- 第二層li -->
            <li
              v-for="(allData3, i) in allData.data.data"
              :key="i"
              class="mt-2"
            >
              <!-- 有連結 -->
              <p
                v-if="allData3.link"
                class="text-justify"
                v-html="getlink(allData3)"
              ></p>

              <!-- 無連結-->
              <div v-else>
                <p
                  class="text-justify"
                  v-html="getInfinity(t(allData3.text))"
                ></p>
              </div>

              <!-- 第三層ul -->
              <ul
                v-if="allData3.data && allData3.data.type == 'ul'"
                :style="allData3.data.style"
              >
                <!-- 第三層li -->
                <li
                  v-for="(allData4, i) in allData3.data.data"
                  :key="i"
                  class="mt-1"
                >
                  <!-- 有連結 -->
                  <p
                    v-if="allData4.link"
                    class="text-justify"
                    v-html="getlink(allData4)"
                  ></p>

                  <!-- 無連結-->
                  <div v-else>
                    <p
                      class="text-justify"
                      v-html="getInfinity(t(allData4.text))"
                    ></p>
                  </div>
                </li>
              </ul>

              <!-- 第三層ol -->
              <ol
                v-if="allData3.data && allData3.data.type == 'ol'"
                :style="allData3.data.style"
              >
                <!-- 第三層li -->
                <li
                  v-for="(allData4, i) in allData3.data.data"
                  :key="i"
                  class="mt-1"
                >
                  <!-- 有連結 -->
                  <p
                    v-if="allData4.link"
                    class="text-justify"
                    v-html="getlink(allData4)"
                  ></p>

                  <!-- 無連結-->
                  <div v-else>
                    <p
                      class="text-justify"
                      v-html="getInfinity(t(allData4.text))"
                    ></p>
                  </div>
                </li>
              </ol>
            </li>
          </ol>
        </li>
      </ol>
      <!-- </div> -->
    </template>

    <template cols="12" v-else-if="allData.componentType === 'iframe'">
      <div class="iframe">
        <iframe
          class="myFrame"
          :width="allData.data.width"
          :height="allData.data.height"
          :src="allData.data.link"
          :title="t(allData.data.title)"
          frameborder="0"
        >
        </iframe>
      </div>
    </template>

    <template cols="12" v-else-if="allData.componentType === 'pdf'">
      <div class="pdf">
        <iframe
          :width="allData.data.width"
          :height="allData.data.height"
          :src="downLoadFile(allData.data.link)"
          :title="t(allData.data.title)"
          frameborder="0"
          type="application/pdf"
        >
        </iframe>
      </div>
    </template>

    <template cols="12" v-else-if="allData.componentType === 'hr'">
      <div style="margin-top: 20px">
        <hr color="#757575" size="1" />
      </div>
    </template>

    <template cols="12" v-else-if="allData.componentType === 'nullData'">
      <div class="nullData"></div>
    </template>
    <template cols="12" v-else-if="allData.componentType === 'big-nullData'">
      <div class="big-nullData"></div>
    </template>

    <template cols="12" v-else-if="allData.componentType === 'img'">
      <div
        v-if="allData.data.length === 1"
        class="d-flex"
        :class="`${getTextAlignment()}`"
      >
        <v-col cols="12" :md="allData.cols ? allData.cols : 12" class="pa-0">
          <img
            :src="getImg(allData.data[0].imgLink)"
            :max-width="allData.width"
            :alt="t(allData.data[0].alt)"
          />
        </v-col>
      </div>

      <!-- 輪播圖 -->
      <div v-else-if="allData.data.length > 1">
        <v-card flat tile>
          <v-row class="carousel pa-0 ma-0 w-100">
            <v-window
              v-model="onboarding"
              class="w-100"
              aria-live="polite"
              aria-roledescription="carousel"
            >
              <v-window-item
                v-for="(img, imgNum) in allData.data"
                :key="`card-${imgNum + 1}`"
              >
                <v-img contain
                  :aspect-ratio="16 / 9"
                  :src="getImg(img.imgLink)"
                  :alt="`${t(img.alt)}`"
                  class="pa-6"
                >
                </v-img>
              </v-window-item>
            </v-window>
            <v-col
              cols="12"
              class="ma-0 pa-0 btn-col d-flex justify-space-between align-center"
            >
              <v-col
                cols="2"
                class="btn-carousel2 h-100 d-flex justify-start align-center"
                @click="prev"
              >
                <v-btn
                  text
                  fab
                  dark
                  small
                  elevation="0"
                  value="上一張圖片"
                  aria-label="上一張圖片"
                >
                  <p class="btn-text-pa" style="visibility: hidden">
                    上一張圖片
                  </p>
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
              </v-col>
              <v-col
                cols="2"
                class="btn-carousel2 h-100 d-flex justify-end align-center"
                @click="next"
              >
                <v-btn
                  text
                  fab
                  dark
                  small
                  elevation="0"
                  value="下一張圖片"
                  aria-label="下一張圖片"
                >
                  <p class="btn-text-pa" style="visibility: hidden">
                    下一張圖片
                  </p>
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-col>
            </v-col>
          </v-row>

          <v-card-actions class="justify-space-between">
            <v-sheet class="mx-auto pa-0 ma-0" width="100%">
              <v-slide-group
                v-model="onboarding"
                mandatory
                center-active
                show-arrows
              >
                <!-- 縮圖 -->
                <v-slide-item
                  v-for="(img, imgNum) in allData.data"
                  :key="`card-${imgNum + 1}`"
                  v-slot="{ active, toggle }"
                >
                  <v-card
                    role="btn"
                    :color="active ? 'bg-blend-black' : ''"
                    :style="{
                      backgroundColor: '#00000080',
                      backgroundBlendMode: 'normal',
                      backgroundImage: `url(${getImg(img.imgLink)})`,
                      backgroundSize: 'cover',
                    }"
                    class="ma-4 pa-0 d-flex align-center justify-center btn-carousel"
                    height="50"
                    width="50"
                    @click="toggle"
                    @keydown.enter="toggle"
                  >
                    <v-row
                      class="d-flex pa-0 ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-scale-transition>
                        <v-icon
                          v-if="active"
                          color="white"
                          size="24"
                          v-text="'mdi-close-circle-outline'"
                        ></v-icon>
                      </v-scale-transition>
                    </v-row>
                  </v-card>
                </v-slide-item>
              </v-slide-group>
            </v-sheet>
          </v-card-actions>
        </v-card>
      </div>
    </template>

    <template cols="12" v-else-if="allData.componentType === 'sdgs'">
      <v-row
        v-if="allData.data"
        class="d-flex pa-0 ma-0 mt-4 justify-center"
        :class="
          allData.alignment === 'left'
            ? 'justify-md-end'
            : allData.alignment === 'right'
            ? 'justify-md-start'
            : ''
        "
      >
        <v-col
          :cols="allData.cols"
          :md="allData.cols_md"
          v-for="(sdgsImg, index) in allData.data"
          :key="index"
          class="pa-1"
          :class="
            allData.alignment === 'right'
              ? 'pr-md-0'
              : allData.alignment === 'left'
              ? 'pl-md-0'
              : 'pa-0'
          "
        >
          <v-img
            max-width="100%" contain
            :src="require(`../../public/tools/img/SDGs/SDGs${sdgsImg}.svg`)"
            :alt="`符合sDGS編號${getSDGStitle(sdgsImg)}的目標`"
          ></v-img>
        </v-col>
      </v-row>
    </template>

    <template cols="12" v-else-if="allData.componentType === 'video'">
      <v-col cols="12" class="videobox pa-0">
        <v-img contain
          src=""
          :aspect-ratio="16 / 9"
          alt=""
          role="presentation"
          aria-hidden="true"
        >
          <iframe
            :src="allData.data.videoLink"
            :title="`嵌入式內容 - ${t(allData.data.videoTitle)}`"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </v-img>
      </v-col>
    </template>
  </div>
</template>

<script>
export default {
  props: ["allData", "titleStyle", "subheadStyle", "textAlignment"],

  data: () => ({
    //輪播用,
    length: 0,
    onboarding: 0,
    model: null, //下方縮圖
  }),

  methods: {
    //輪播用
    next() {
      this.onboarding =
        this.onboarding + 1 === this.length ? 0 : this.onboarding + 1;
    },
    prev() {
      this.onboarding =
        this.onboarding - 1 < 0 ? this.length - 1 : this.onboarding - 1;
    },

    //檢查∞符號
    getInfinity(text) {
      if (text && text.includes("∞") > -1) {
        let tAll = text.split("∞");
        let result = tAll.join("<sup>∞</sup>");
        return result;
      } else {
        return text; // 如果文本中不存在∞符號，直接返回原始文本
      }
    },

    //返回
    getTextAlignment(data) {
      if (data) {
        this.textAlignment = data;
      }

      if (this.textAlignment === "left") {
        return "justify-start text-left";
      }
      if (
        this.textAlignment === "center" ||
        this.textAlignment === "" ||
        !this.textAlignment
      ) {
        return "justify-center text-center";
      }
      if (this.textAlignment === "right") {
        return "justify-end text-right";
      }
    },

    getTitleStyle() {
      if (this.titleStyle === "") {
        return "color-title";
      } else {
        return this.titleStyle;
      }
    },
    getSubheadStyle() {
      if (this.subheadStyle === "") {
        return "color-subtitle font-h3 font-B";
      } else {
        return this.subheadStyle;
      }
    },
    getlink(data) {
      let newText = data.text;

      data.link.forEach((linkItem) => {
        let fileExtension = "";

        if (linkItem.link.includes(".pdf")) {
          fileExtension = ".pdf(另開新視窗)";
        }
        //原Word檔
        else if (linkItem.link.includes(".doc")) {
          fileExtension = ".doc(下載檔案)";
        } else if (linkItem.link.includes(".docx")) {
          fileExtension = ".docx(下載檔案)";
        }
        //原Excel檔
        else if (linkItem.link.includes(".xls")) {
          fileExtension = ".xls(下載檔案)";
        } else if (linkItem.link.includes(".xlsx")) {
          fileExtension = ".xlsx(下載檔案)";
        }
        //原PPT
        else if (linkItem.link.includes(".ppt")) {
          fileExtension = ".ppt(另開新視窗)";
        } else if (linkItem.link.includes(".pptx")) {
          fileExtension = ".pptx(另開新視窗)";
        }

        //新版格式跟其他
        else if (linkItem.link.includes(".odt")) {
          //Word
          fileExtension = ".odt(下載檔案)";
        } else if (linkItem.link.includes(".ods")) {
          //Excel
          fileExtension = ".ods(下載檔案)";
        } else if (linkItem.link.includes(".odp")) {
          //PPT
          fileExtension = ".odp(下載檔案)";
        } else if (linkItem.link.includes(".odg")) {
          fileExtension = ".odg(下載檔案)";
        } else if (linkItem.link.includes(".odb")) {
          fileExtension = ".odb(下載檔案)";
        } else if (linkItem.link.includes(".odf")) {
          fileExtension = ".odf(另開新視窗)";
        } else {
          fileExtension = "另開新視窗";
        }

        newText = newText.replace(
          linkItem.text,
          `
        <a class="my-a"
           href="${this.downLoadFile(linkItem.link)}" target="_blank" 
           title="${linkItem.fileName}${fileExtension}" >
          ${linkItem.text}</a>`
        );
      });

      return newText;
    },

    downLoadFile(fileName) {
      if (fileName.includes("https")) {
        return fileName;
      } else {
        // 使用完整路径下载文件
        return `/tools/files/${fileName}`;
      }
    },
    getImg(imgName) {
      if (imgName.includes("https")) {
        return imgName;
      } else {
        // 使用完整路径下载文件
        return `/tools/img/${imgName}`;
      }
    },
    getSDGStitle(num) {
      if (num == "01") {
        return `${num}消除各地一切形式的貧窮`;
      }
      if (num == "02") {
        return `${num}消除飢餓，達成糧食安全，改善營養及促進永續農業`;
      }
      if (num == "03") {
        return `${num}消除飢餓，達成糧食安全，改善營養及促進永續農業`;
      }
      if (num == "04") {
        return `${num}確保有教無類、公平以及高品質的教育，及提倡學習`;
      }
      if (num == "05") {
        return `${num}實現性別平等，並賦予婦女權力`;
      }
      if (num == "06") {
        return `${num}確保所有人都能享有水及衛生及其永續管理`;
      }
      if (num == "07") {
        return `${num}確保所有的人都可取得負擔得起、可靠的、永續的，及現代的能源`;
      }
      if (num == "08") {
        return `${num}促進包容且永續的經濟成長，達到全面且有生產力的就業，讓每一個人都有一份好工作`;
      }
      if (num == "09") {
        return `${num}建立具有韌性的基礎建設，促進包容且永續的產業發展，並加速創新`;
      }
      if (num == "10") {
        return `${num}減少國內及國家間不平等`;
      }
      if (num == "11") {
        return `${num}促使城市與人類居住具包容、安全、韌性及永續性`;
      }
      if (num == "12") {
        return `${num}確保永續消費及生產模式`;
      }
      if (num == "13") {
        return `${num}採取緊急措施以因應氣候變遷及其影響`;
      }
      if (num == "14") {
        return `${num}保育及永續利用海洋與海洋資源，以確保永續發展`;
      }
      if (num == "15") {
        return `${num}保護、維護及促進陸域生態系統的永續使用，永續的管理森林，對抗沙漠化，終止及逆轉土地劣化，並遏止生物多樣性的喪失`;
      }
      if (num == "16") {
        return `${num}促進和平且包容的社會，以落實永續發展；提供司法管道給所有人；在所有階層建立有效的、負責的且包容的制度`;
      }
      if (num == "17") {
        return `${num}強化永續發展執行方法及活化永續發展全球夥伴關係`;
      }
    },
  },
};
</script>

<style lang="scss">
.myP {
  width: fit-content;
}

.bannerSubtitle::after {
  content: "\00A0"; /* 使用 Unicode 表示半角空格 */
}
.nullData {
  height: 20px;
}
.big-nullData {
  height: calc(2.986em * 1.5);
}

.videobox {
  position: relative;
  // width: 100%;
  // padding-bottom: 54%;
  //   @media only screen and (min-width: 960px) {
  //     width: calc( (100% / 12) * 9);
  //     padding-bottom: 40%;
  //   }
}
.videobox iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.my-a {
  font-size: 0.825em;
  padding: 2px 12px;
  margin: 0px 2px;
  border-radius: 99em;
  background-color: var(--second);
  color: var(--te-black) !important;
  transition: all 0.2s ease-out;
}
.my-a:hover {
  color: var(--te-white) !important;
  background-color: var(--third);
}
.my-a:focus-within {
  color: var(--te-white) !important;
  background-color: var(--third);
}

//沒整理
.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}

//圖片遮罩
.bg-blend-black {
  // 設置背景混和模式為相乘模式
  background-blend-mode: multiply !important;
}
.btn-carousel:focus-within {
  border: 5px solid var(--third);
}
.btn-carousel2 {
  position: relative;
  .v-btn {
    background-color: #00000040;
  }
  .btn-text-pa {
    position: absolute;
  }
}
.carousel {
  position: relative;
  .btn-col {
    position: absolute;
    width: 100%;
    height: 100%;
    visibility: hidden;
  }
}
.carousel:hover {
  .btn-col {
    visibility: visible;
  }
}
</style>
